import Grid from "@mui/material/Grid"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { CancelButton, Icons } from "@src/components"
import React from "react"
import useRouterClient from "@src/hooks/use-router-client"
import CollectionCard from "@src/components/CollectionCard"
import { ROUTES } from "@src/constants"
import type { Collection } from "@src/types/collection"
import { useTranslation } from "react-i18next"

interface Props {
  label?: string
  limit?: number
  data: Collection[]
}

function OtherCollection(props: Props) {
  const { t } = useTranslation()
  const { label = t("other_collections"), limit = 4, data } = props
  const { router } = useRouterClient()
  const handleRedirect = (path: string) => () => {
    router.push(path)
  }

  const renderContent = () => {
    if (data?.length === 0) {
      return (
        <Typography
          variant="body1"
          sx={{
            marginTop: 3,
            marginLeft: 1.2,
            fontSize: {
              xs: 14,
              md: 16
            },
            fontWeight: 400,
            lineHeight: "20px"
          }}
        >
          Không có bộ sưu tập nào khác
        </Typography>
      )
    }

    return (data || [])?.slice(0, limit).map((collection, index) => (
      <Grid key={index} item xs={6} lg={6}>
        <CollectionCard data={collection} sx={{ background: "#f6f6f6" }} />
      </Grid>
    ))
  }

  return (
    <Stack direction={"column"} width={"100%"} overflow="hidden">
      <Typography
        variant="h3"
        sx={{
          fontSize: {
            xs: 16,
            md: 30
          },
          fontWeight: 700,
          lineHeight: "36px"
        }}
      >
        {label}
      </Typography>
      <Grid
        container
        spacing={1}
        sx={{
          maxWidth: "xl",
          margin: "auto",
          paddingRight: "0px !important",
          width: "calc(100% + 8px) !important",
          marginLeft: "-8px",
          "& .MuiGrid-item": {
            padding: "8px"
          }
        }}
      >
        {renderContent()}
      </Grid>
      <Stack
        display={{
          xs: "none",
          md: "flex"
        }}
        mt={3}
        justifyContent="center"
      >
        <CancelButton
          label={t("see_more")}
          height={"44px"}
          endIcon={<Icons name="arrow-right" />}
          sx={{
            color: "#262626 !important",
            minHeight: "44px",
            minWidth: "300px"
          }}
          onClick={handleRedirect(ROUTES.COLLECTION)}
        />
      </Stack>
    </Stack>
  )
}

export default OtherCollection
